import { Card } from "react-bootstrap";
import {TracesListHeader} from "./components/TracesListHeader.tsx";
import {TracesListTable} from "./components/TracesListTable.tsx";


export const TracesList = () => {

    return (

        <>
            <Card className="custom-card">
                <TracesListHeader />
                <TracesListTable />
            </Card>
        </>

    )
}
